/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useContext, useEffect, useState} from 'react'
import {Link, useParams, useLocation, useNavigate} from 'react-router-dom'
import {getrazarpay, updaterazarpay} from '../list/core/_requests'
import {Button, Modal} from 'react-bootstrap'
import {AlertContext} from '../../../../../_metronic/layout/components/alert-context'

export function ViewUser() {
  const {showAlert} = useContext(AlertContext)
  const location = useLocation()
  const {id} = useParams()
  const navigate = useNavigate()
  const [data, setData] = useState<any>([])
  const [showModal, setShow] = useState(false)
  const [keyVal, setkeyVal] = useState('')
  const [SkeyVal, setSkeyVal] = useState('')
  const handleClose = () => setShow(false)
  useEffect(() => {
    getrazarpay().then((res: any) => {
      setData(res.data?.data[0])
      setSkeyVal(res.data?.data[0]?.razor_secretkey)
      setkeyVal(res.data?.data[0]?.razor_key)
    })
  }, [])
  const handleEdit = () => {
    
    setShow(true)
  }
  const SubmitHandle = () => {
    const datas = {
      key: keyVal,
      secret_key: SkeyVal,
      id: data?.id,
    }

    updaterazarpay(datas).then((res) => {
      

      showAlert(res?.data?.Message, res?.data?.Code)
      navigate('/settings', {replace: true})
    })

    
    setShow(true)
  }
  const handleInputKey = (e: any) => {
    setkeyVal(e.target.value)
  }
  const handleInputSKey = (e: any) => {
    setSkeyVal(e.target.value)
  }
  const editrazar = 'settings/edit/' + data?.id

  return (
    <>
      <div className='tab-content' id='myTabContent'>
        <div className='mb-xl-10 tab-pane fade active show' id='kt_tab_overview' role='tabpanel'>
          <div className='card mb-5 mb-xl-10'>
            <div className='card-header cursor-pointer'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>Details</h3>
              </div>
              <button onClick={handleEdit} className='btn btn-primary align-self-center'>
                Edit
              </button>
            </div>

            <div className='card-body p-9'>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Key</label>

                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>{data?.razor_key}</span>
                </div>
              </div>
              <div className='row mb-7'>
                <label className='col-lg-4 fw-bold text-muted'>Secret Key</label>

                <div className='col-lg-8'>
                  <span className='fw-bolder fs-6 text-dark'>{data?.razor_secretkey}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Data</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row col-lg-12 mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Key</label>

            <div className='col-lg-8'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Enter Secret Key'
                value={keyVal}
                onChange={(e) => {
                  handleInputKey(e)
                }}
              />
            </div>
          </div>
          <div className='row  col-lg-12 mb-7'>
            <label className='col-lg-4 fw-bold text-muted'>Secret Key</label>

            <div className='col-lg-8'>
              <input
                type='text'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Enter Secret Key'
                value={SkeyVal}
                onChange={(e) => {
                  handleInputSKey(e)
                }}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Not Now
          </Button>
          <Button variant='primary' onClick={SubmitHandle}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
